import { IConfigurations } from '@epicuro-next/platform/configuration';

export const POWER_LIST_NAMESPACE = 'power-list';

/**
 * configuration keys for this module
 */
export enum PowerListConfigurationKeys {
  HideExcludeButton = 'hide-exclude-button',
}
/**
 * Configuration return types and default values for this module
 */
export interface PowerListConfigurations
  extends IConfigurations<PowerListConfigurationKeys> {
  [PowerListConfigurationKeys.HideExcludeButton]: boolean;
}
